"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Text_1 = __importDefault(require("./Text"));
const Number_1 = __importDefault(require("./Number"));
const Color_1 = __importDefault(require("./Color"));
const Boolean_1 = __importDefault(require("./Boolean"));
const Object_1 = __importDefault(require("./Object"));
const Select_1 = __importDefault(require("./Select"));
const Date_1 = __importDefault(require("./Date"));
const Array_1 = __importDefault(require("./Array"));
const Radio_1 = __importDefault(require("./Radio"));
exports.default = {
    text: Text_1.default,
    number: Number_1.default,
    color: Color_1.default,
    boolean: Boolean_1.default,
    object: Object_1.default,
    select: Select_1.default,
    date: Date_1.default,
    array: Array_1.default,
    radio: Radio_1.default,
    'inline-radio': Radio_1.default,
    'multi-select': Select_1.default,
    range: Number_1.default,
};
